// 菜单，侧边栏
import BcosHome from "./modules/bcos/home"
import BcosChain from "./modules/bcos/chain"
import BcosContract from "./modules/bcos/contract"
import BcosPrivateKey from "./modules/bcos/private-key"
import BcosSystem from "./modules/bcos/system"
import BcosApp from "./modules/bcos/app"
import BcosMonitor from "./modules/bcos/monitor"
import BcosAudit from "./modules/bcos/audit"
import BcosEvent from "./modules/bcos/event"
import BcosBrowser from "./modules/bcos/browser"


export default [
    BcosHome,
    BcosChain,
    BcosContract,
    BcosPrivateKey,
    BcosSystem,
    BcosApp,
    BcosMonitor,
    BcosAudit,
    BcosEvent,
    BcosBrowser,
];